$(document).ready(function() {
    let $chart = $('svg.circle-chart');
    let circleSpacing = 0.3;

    $chart.each(function(i, chart) {
        let $thisChart = $(chart);
        let $legend = $thisChart.parents('.chart').find('.legend');
        let $circles = $thisChart.find('circle');
        let percentage = [circleSpacing];

        $circles.each(function(index, circle) {
            let $circle = $(circle);

            let offset = percentage.reduce((a, b) => a + b, 0);
            offset = offset - (($circles.length + 1) * circleSpacing)
            $circle.attr('stroke-dashoffset', -offset);

            let value = $circle.attr('stroke-dasharray');
            value = value.split(",");
            value = parseInt(value[0]);
            percentage.push(value + circleSpacing);

            let name = $circle.attr('name');
            let indicator = name.split(' ').join('_-_');
            $circle.attr('name', indicator);
            let newButton = `<label class="btn btn-quaternary active" name="${indicator}">${name}</label>`;
            $legend.append(newButton);

            $circle.on('mouseenter', function() {
                let percent = $(this).attr('stroke-dasharray');
                percent = percent.split(",");
                percent = parseInt(percent[0]);
                $(this).parents('.chart').find('.circle-chart__text.chart-percent').html('<h2>' + percent + '%</h2>');
                $(this).parents('.chart').find('.circle-chart__text.chart-title').addClass('dimm');
                $(this).siblings().addClass('inactive');
            }).on('mouseleave', function() {
                $(this).parents('.chart').find('.circle-chart__text.chart-percent').html('');
                $(this).parents('.chart').find('.circle-chart__text.chart-title').removeClass('dimm');
                $(this).siblings().removeClass('inactive');
            });

            $thisChart.parents('.chart').find('label').on('mouseenter', function() {
                let indicator = $(this).attr('name');
                let percent = $thisChart.find('circle[name="' + indicator + '"]').attr('stroke-dasharray');
                percent = percent.split(",");
                percent = parseInt(percent[0]);
                $(this).parents('.chart').find('.circle-chart__text.chart-percent').html('<h2>' + percent + '%</h2>');
                $(this).parents('.chart').find('.circle-chart__text.chart-title').addClass('dimm');
                $(this).parents('.chart').find('circle[name="' + indicator + '"]').siblings().addClass('inactive');
            }).on('mouseleave', function() {
                let indicator = $(this).attr('name');
                $(this).parents('.chart').find('.circle-chart__text.chart-percent').html('');
                $(this).parents('.chart').find('.circle-chart__text.chart-title').removeClass('dimm');
                $(this).parents('.chart').find('circle[name="' + indicator + '"]').siblings().removeClass('inactive');
            });
        });
    });



});